"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_SAFE_AREA = exports.GAME_PADDING_Y = exports.GAME_PADDING_X = exports.GAME_HEIGHT = exports.GAME_WIDTH = void 0;
exports.GAME_WIDTH = 498;
exports.GAME_HEIGHT = 809;
exports.GAME_PADDING_X = 42;
exports.GAME_PADDING_Y = 42;
exports.GAME_SAFE_AREA = new PIXI.Rectangle(exports.GAME_PADDING_X, exports.GAME_PADDING_Y, exports.GAME_WIDTH - (exports.GAME_PADDING_X * 2), exports.GAME_HEIGHT - (exports.GAME_PADDING_Y * 2));
